import StepperDataExport from '../3modules/DataExport/StepperDataExport'
import AuditDataSelectDataSetDropdown from '../2compounds/Select/AuditTrailDataTypeDropdown'
import DateRangeSelector from '../3modules/DataExport/DateRangeSelector'
import ConfirmationMessage from '../3modules/DataExport/ConfirmationMessage'
import dayjs from 'dayjs'
import FormErrorSnackbar from '../2compounds/FormErrorSnackbar'

const AuditLogAuditTrailTemplate = ({dataType, onDataTypeChange, toDate, setToDate, fromDate, setFromDate, handleExport, disabled, isErrorSnackbarOpen, setIsErrorSnackbarOpen}) => {
    const steps = ['Select Data Set', 'Select Date Range', 'Export Audit Data']
    const DataSetDropdown = (<AuditDataSelectDataSetDropdown value={dataType} onChange={onDataTypeChange} />)

    const errorSnackbarMessage = 'Something went wrong. Please try it again later.'


    const helperTextForDateRange = 'Time period must be 30 days or less'
    const minFromDate = toDate ? dayjs(toDate).subtract(30, 'd') : null
    const maxToDate = fromDate ? dayjs(fromDate).add(30, 'd') : null
    const DateRange = (<DateRangeSelector toDate={toDate} setToDate={setToDate}
                                          fromDate={fromDate} setFromDate={setFromDate}
                                          helperText={helperTextForDateRange} maxToDate={maxToDate} minFromDate={minFromDate} />)
    const selectedValuesObject = {
        'Data Set': dataType,
        'From': fromDate,
        'To': toDate
    }
    const Confirmation = (<ConfirmationMessage selectedValuesObject={selectedValuesObject} />)

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return DataSetDropdown
            case 1:
                return DateRange
            case 2:
                return Confirmation
            default:
                return 'Unknown step';
        }
    }

    return (
        <>
            <StepperDataExport getStepContent={getStepContent} steps={steps} handleExportButton={handleExport} disabled={disabled} />
            <FormErrorSnackbar content={errorSnackbarMessage} isSnackbarOpen={isErrorSnackbarOpen} setIsSnackbarOpen={setIsErrorSnackbarOpen} />
        </>
    )
}

export default AuditLogAuditTrailTemplate
